(() => {
  const normalizeArticleMedia = (root) => {
    if (root.dataset.normalizeArticleMedia !== 'true' || root.dataset.articleMediaNormalized === 'true') return;

    const images = Array.from(root.querySelectorAll('img:not(.article-detail__media img)'));

    images.forEach((image) => {
      const imageLink = image.parentElement?.tagName === 'A' && image.parentElement.children.length === 1
        ? image.parentElement
        : null;
      const mediaNode = imageLink || image;
      const sourceContainer = mediaNode.parentElement;

      if (!sourceContainer || !root.contains(sourceContainer)) return;

      let owningListItem = sourceContainer.closest('li');
      while (owningListItem) {
        const parentListItem = owningListItem.parentElement?.closest('li');
        if (!parentListItem || !root.contains(parentListItem)) break;
        owningListItem = parentListItem;
      }

      if (root.dataset.generateMissingAlt === 'true' && image.alt.trim() === '') {
        const interpolate = (template, values) => Object.entries(values).reduce(
          (result, [key, value]) => result.replaceAll(`[${key}]`, String(value)),
          String(template || '')
        );
        const orderedStepItems = owningListItem?.parentElement?.tagName === 'OL'
          ? Array.from(owningListItem.parentElement.children).filter((element) => element.tagName === 'LI')
          : [];
        const stepNumber = orderedStepItems.indexOf(owningListItem) + 1;
        const previousHeadings = Array.from(root.querySelectorAll('h2, h3, h4'))
          .filter((heading) => (
            heading !== sourceContainer
            && (heading.compareDocumentPosition(sourceContainer) & Node.DOCUMENT_POSITION_FOLLOWING) !== 0
          ));
        const previousHeading = previousHeadings[previousHeadings.length - 1];

        if (stepNumber > 0) {
          image.alt = interpolate(root.dataset.altStep, { step: stepNumber });
        } else if (previousHeading?.textContent.trim()) {
          image.alt = interpolate(root.dataset.altHeading, { heading: previousHeading.textContent.trim() });
        } else {
          image.alt = root.dataset.altDefault || '';
        }
      }

      const figure = document.createElement('figure');
      figure.className = 'article-detail__media';
      figure.append(mediaNode);

      image.removeAttribute('style');
      image.loading = 'lazy';
      image.decoding = 'async';

      const sourceTag = sourceContainer.tagName;
      const isMediaOnlyWrapper = ['P', 'H2', 'H3', 'H4'].includes(sourceTag)
        && sourceContainer.textContent.trim() === ''
        && sourceContainer.children.length === 0;

      if (owningListItem) {
        owningListItem.append(figure);
      } else if (isMediaOnlyWrapper) {
        sourceContainer.replaceWith(figure);
      } else if (sourceContainer === root) {
        root.append(figure);
      } else {
        sourceContainer.after(figure);
      }
    });

    root.querySelectorAll('h2:empty, h3:empty, h4:empty, p:empty').forEach((element) => element.remove());
    root.dataset.articleMediaNormalized = 'true';
  };

  const initializeArticleMedia = (scope = document) => {
    scope.querySelectorAll('[data-article-content]').forEach(normalizeArticleMedia);
  };

  initializeArticleMedia();
  document.addEventListener('shopify:section:load', (event) => initializeArticleMedia(event.target));
})();
